import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 当前组织下的数字资产列表
export const setDigitalAssets: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 指定类目的属性列表
export const setDigitalAttrsByDef: Mutation<IModuleState> = (state, payload) => {
  state.defAttrs.data = payload.data;
  state.defAttrs.loading = !!payload.loading;
};

// 所有可用的类目列表
export const setAllDefsByOrgType: Mutation<IModuleState> = (state, payload) => {
  state.allDefs.data = payload.data;
  state.allDefs.loading = !!payload.loading;
};

// 数字资产详情
export const setDigitalAssetDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 根据资产编码查询到的资产变更日志
export const setAssetLogsByCode: Mutation<IModuleState> = (state, payload) => {
  state.assetLogsByCode.data = payload.data;
  state.assetLogsByCode.pageNum = payload.pageNum;
  state.assetLogsByCode.pageSize = payload.pageSize;
  state.assetLogsByCode.total = payload.total;
  state.assetLogsByCode.loading = !!payload.loading;
};

// 根据类目查询到的资产变更日志
export const setAssetLogsByDef: Mutation<IModuleState> = (state, payload) => {
  state.assetLogsByDef.data = payload.data;
  state.assetLogsByDef.pageNum = payload.pageNum;
  state.assetLogsByDef.pageSize = payload.pageSize;
  state.assetLogsByDef.total = payload.total;
  state.assetLogsByDef.loading = !!payload.loading;
};

// 检索条件类型列表
export const setConditionTypes: Mutation<IModuleState> = (state, payload) => {
  state.conditionTypes.data = payload.data;
  state.conditionTypes.loading = !!payload.loading;
};

// 文件类型列表
export const setDigitalFileTypes: Mutation<IModuleState> = (state, payload) => {
  state.fileTypes.data = payload.data;
  state.fileTypes.loading = !!payload.loading;
};

// 上传的验证信息
export const setUploadPolicy: Mutation<IModuleState> = (state, payload) => {
  state.uploadPolicy.data = payload.data;
  state.uploadPolicy.loading = payload.loading;
};

// 编码是否重复
export const setDigitalAssetExisted: Mutation<IModuleState> = (state, payload) => {
  state.existed.data = payload.data;
  state.existed.loading = !!payload.loading;
};

// dialog 弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.data = payload.data;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.data = payload.data;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

// 搜索频次计数
export const setSearchCount: Mutation<IModuleState> = (state, payload) => {
  state.searchCount = payload;
};

// 搜索条件是否校验错误
export const setValidError: Mutation<IModuleState> = (state, payload) => {
  state.validError = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
